import useSWR from 'swr'
import useSWRImmutable from 'swr/immutable'
import {
  Button,
  Flex,
  Text,
  Heading,
  Grid,
  GridItem,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'
import {PropTypes} from 'prop-types'
import {useTranslation} from 'react-i18next'

import {fetcher} from '../../../../api'
import {useRails} from '../../../contexts/rails'
import useLogoUpload from '../../../hooks/useLogoUpload'
import {Introduction, ContinueWithoutSavingDialog} from '../components'

import LogoUpload from '../../LogoUpload'

const LogoUploadModal = ({goToNextStep}) => {
  const {t} = useTranslation('invitePayers')
  const {organisation} = useRails()

  const {
    data: business,
    _isLoading,
    mutate,
  } = useSWR(
    `/api/suppliers/${organisation.currentSupplier.id}/business_settings`,
    fetcher,
  )

  const {_data, isLoading: isLoadingPersonal} = useSWRImmutable(
    `/api/personal_settings`,
    fetcher,
  )

  const {onUpdateLogo, onDestroyLogo, directUploadsUrl} = useLogoUpload(mutate)
  const {
    isOpen: isConfirmationOpen,
    onOpen: onConfirmationOpen,
    onClose: onConfirmationClose,
  } = useDisclosure()

  const handleConfirmClose = () => {
    onConfirmationClose()
    goToNextStep('invitation_type')
  }

  const handleOnClick = () => {
    if (business?.settings.businessLogoUrl) {
      return goToNextStep('invitation_type')
    }

    return onConfirmationOpen()
  }

  return (
    <>
      <Grid templateColumns="repeat(3, 1fr)" height="full">
        <Introduction />
        <ModalCloseButton m={2} />
        <GridItem pt="lg" colSpan={2} align="center" alignContent="center">
          <Flex direction="column" width="390px" gap="md" color="black">
            <Heading
              fontWeight="normal"
              lineHeight="90%"
              align="left"
              justify="center"
            >
              {t('modal.steps.logoUpload.contentSection.title')}
            </Heading>
            <Text fontWeight="normal" align="left" lineHeight="150%">
              {t('modal.steps.logoUpload.contentSection.content')}
            </Text>

            <Flex direction="column" gap="sm">
              <LogoUpload
                logoUrl={business?.settings.businessLogoUrl}
                isLoading={isLoadingPersonal}
                directUploadsUrl={directUploadsUrl}
                onUpdate={onUpdateLogo}
                onDestroy={onDestroyLogo}
              />
              <Text
                fontWeight="normal"
                align="left"
                lineHeight="125%"
                fontSize="xs"
              >
                {t('modal.steps.logoUpload.contentSection.disclaimer')}
              </Text>
            </Flex>
            <Button
              mt="xs"
              variant="primary"
              size="md"
              width="45%"
              onClick={handleOnClick}
            >
              <Text>{t('modal.steps.logoUpload.ctaButton')}</Text>
            </Button>
          </Flex>
        </GridItem>
      </Grid>
      <ContinueWithoutSavingDialog
        isOpen={isConfirmationOpen}
        onClose={onConfirmationClose}
        onConfirmExit={handleConfirmClose}
      />
    </>
  )
}

LogoUploadModal.propTypes = {
  goToNextStep: PropTypes.func.isRequired,
}

export default LogoUploadModal
